export default __webpack_public_path__ + "static/media/Snd_TryL.39996114.mp3";